import { useState } from "react";
import AskAiModal from "./partials/AskAiModal";
import BasicInfo from "./partials/BasicInfo";
import ExperienceSkills from "./partials/ExperienceSkills";

const StepOne = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className="w-full flex h-2/3 text-sm xl:text-lg">
      <BasicInfo />
      <ExperienceSkills setOpen={setOpen} />
      <AskAiModal open={open} setOpen={setOpen} />
    </div>
  );
};

export default StepOne;
